import React from 'react';
import ExpandableTracking from './expandables';

const renderExpandables = (type, rowData, expanderData, setExpanderData, values) => {
  switch (type) {
    case 'expandableTracking':
      return (
        <ExpandableTracking data={rowData} expanderData={expanderData} setExpanderData={setExpanderData} values={values} />
      );

    default:
      return (<div>Nenhum componente</div>);
  }
};

export default renderExpandables;
